module.exports = __webpack_public_path__ + "media/images/en/approve-08d45f833324e3b51611f92e39d01dd8.png";